export const navHospitalsProps = {
  basename: "/plataforma/unidades",
};
